import React, { useState } from "react";
import { HomeUiProvider } from "../../context/HomeUiContext";
import { useTouchHandler } from "../../hooks/useTouchHandler";
import CatalogChrome from "./CatalogChrome";

export default function HomePage() {
  useTouchHandler();
  const [cal, setCal] = useState(() => {
    const now = new Date();
    return { y: now.getFullYear(), m: now.getMonth() };
  });
  const [calOpen, setCalOpen] = useState(false);
  const [availBannerShow, setAvailBannerShow] = useState(false);
  const [dateToast, setDateToast] = useState(false);
  const [orderFormOpen, setOrderFormOpen] = useState(false);

  const shiftMonth = (dir) => {
    setCal(({ y, m }) => {
      let nm = m + dir;
      let ny = y;
      if (nm > 11) {
        nm = 0;
        ny += 1;
      }
      if (nm < 0) {
        nm = 11;
        ny -= 1;
      }
      return { y: ny, m: nm };
    });
  };

  return (
    <HomeUiProvider>
      <div className="app-shell page-catalog">
        <CatalogChrome
          availBannerShow={availBannerShow}
          setAvailBannerShow={setAvailBannerShow}
          calOpen={calOpen}
          setCalOpen={setCalOpen}
          calYear={cal.y}
          calMonth={cal.m}
          shiftMonth={shiftMonth}
          dateToast={dateToast}
          setDateToast={setDateToast}
          orderFormOpen={orderFormOpen}
          setOrderFormOpen={setOrderFormOpen}
        />
      </div>
    </HomeUiProvider>
  );
}
